/**
 * VSME text-domain-bound i18n helpers for mission-core modules that originated in vsme-plugin.
 *
 * Modules moved from vsme-plugin keep their strings on the `vsme-plugin` text domain so the
 * rendered/translated output is byte-identical to before the move. The text domain must match
 * the domain registered in PHP; until translation JSON is loaded these return the source string.
 */
import { createI18n } from '@tpct/admin-ui/i18n/createI18n';

export const { __, _x_, _n_, sprintf } = createI18n('vsme-plugin');
